module.exports = __webpack_public_path__ + "img/6_15.164df665.png";